<template>
<div class="chapter">
<div class="inner_page">
<nav epub:type="toc" id="toc"><h1>Contents</h1><ol><li id="level1-titlepage"><span href="#/titlepage" title="Link target outside of Sample">Title Page</span></li>
<li id="level1-toc"><a href="#/toc">Contents</a></li>
<li id="level1-front3"><a href="#/front01">Copyright</a></li>
<li id="level1-front4"><a href="#/front02">Dedication</a></li>
<li id="level1-front5"><a href="#/front03">Prologue</a></li>
<li id="c01"><a href="#/c01">One</a>
</li>
<li id="c02"><a href="#/c02">Two</a>
</li>
<li id="c03"><span href="#/c03" title="Link target outside of Sample">Three</span>
</li>
<li id="c04"><span href="#/c04" title="Link target outside of Sample">Four</span>
</li>
<li id="c05"><span href="#/c05" title="Link target outside of Sample">Five</span>
</li>
<li id="c06"><span href="#/c06" title="Link target outside of Sample">Six</span>
</li>
<li id="c07"><span href="#/c07" title="Link target outside of Sample">Seven</span>
</li>
<li id="c08"><span href="#/c08" title="Link target outside of Sample">Eight</span>
</li>
<li id="c09"><span href="#/c09" title="Link target outside of Sample">Nine</span>
</li>
<li id="c10"><span href="#/c10" title="Link target outside of Sample">Ten</span>
</li>
<li id="c11"><span href="#/c11" title="Link target outside of Sample">Eleven</span>
</li>
<li id="c12"><span href="#/c12" title="Link target outside of Sample">Twelve</span>
</li>
<li id="c13"><span href="#/c13" title="Link target outside of Sample">Thirteen</span>
</li>
<li id="c14"><span href="#/c14" title="Link target outside of Sample">Fourteen</span>
</li>
<li id="c15"><span href="#/c15" title="Link target outside of Sample">Fifteen</span>
</li>
<li id="c16"><span href="#/c16" title="Link target outside of Sample">Sixteen</span>
</li>
<li id="c17"><span href="#/c17" title="Link target outside of Sample">Seventeen</span>
</li>
<li id="c18"><span href="#/c18" title="Link target outside of Sample">Eighteen</span>
</li>
<li id="c19"><span href="#/c19" title="Link target outside of Sample">Nineteen</span>
</li>
<li id="c20"><span href="#/c20" title="Link target outside of Sample">Twenty</span>
</li>
<li id="c21"><span href="#/c21" title="Link target outside of Sample">Twenty-One</span>
</li>
<li id="c22"><span href="#/c22" title="Link target outside of Sample">Twenty-Two</span>
</li>
<li id="c23"><span href="#/c23" title="Link target outside of Sample">Twenty-Three</span>
</li>
<li id="c24"><span href="#/c24" title="Link target outside of Sample">Twenty-Four</span>
</li>
<li id="c25"><span href="#/c25" title="Link target outside of Sample">Twenty-Five</span>
</li>
<li id="c26"><span href="#/c26" title="Link target outside of Sample">Twenty-Six</span>
</li>
<li id="c27"><span href="#/c27" title="Link target outside of Sample">Twenty-Seven</span>
</li>
<li id="level1-back60"><span href="#/back01" title="Link target outside of Sample">Epilogue</span></li>
<li id="level1-back61"><span href="#/back02" title="Link target outside of Sample">Acknowledgments</span></li>
<li id="level1-back62"><span href="#/back03" title="Link target outside of Sample">Sample Chapter from THE NIGHT SHE WON MISS AMERICA</span></li>
<li id="level1-back63"><span href="#/back04" title="Link target outside of Sample">Buy the Book</span></li>
<li id="level1-back64"><span href="#/back05" title="Link target outside of Sample">About the Author</span></li>
<li id="level1-back65"><span href="#/back06" title="Link target outside of Sample">Connect with HMH</span></li></ol></nav>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// toc.vue?1915d82a